import { useMemo } from 'react';
import _ from 'underscore';

const DEFAULT_OPTIONS = {};

export const postponeReadConfig = {
  fetch: { postponeRead: true },
};

export const usePostponeReadVariables = lookupCacheByVariables => useMemo(
  () => (
    lookupCacheByVariables ?
      {
        fetch: {
          postponeRead: true,
          lookupCacheByVariables,
        },
        refetch: {
          lookupCacheByVariables,
        },
      } :
      {
        fetch: {
          postponeRead: true,
        },
      }),
  [lookupCacheByVariables]
);

export const useCustomerLevelVariables = ({
  customerId,
  userId,
}) => useMemo(() => ({
  locator: {
    descriptor: {
      uid: userId,
      cid: customerId,
      customer_id: customerId,
    },
  },
}), [userId, customerId]);

export const useAccountLevelVariables = ({
  customerId,
  accountId,
  userId,
  options = DEFAULT_OPTIONS,
}) => useMemo(() => (_.extend({}, options, {
  locator: {
    descriptor: {
      uid: userId,
      cid: customerId,
      aid: accountId,
      customer_id: customerId,
      account_id: accountId,
    },
    order: ['cid', 'aid'],
  },
})), [options, userId, customerId, accountId]);
